(function () {
  'use strict';

  var overlay    = document.getElementById('cwcdm-overlay');
  var modal      = document.getElementById('cwcdm-modal');
  var closeBtn   = document.getElementById('cwcdm-close');
  var imgWrap    = document.getElementById('cwcdm-img-wrap');
  var cmLink     = document.getElementById('cwcdm-cm-link');
  var titleEl    = document.getElementById('cwcdm-title-el');
  var subEl      = document.getElementById('cwcdm-sub-el');
  var contextEl  = document.getElementById('cwcdm-context');

  if (!overlay || !modal) return;

  // ── State ──────────────────────────────────────────────────────────────────
  var _card      = null;
  var _mode      = 'pricedex';
  var _listId    = null;
  var _lists     = [];
  var _onSave    = null;
  var _onClose   = null;
  var _qty       = 1;
  var _authFn    = null;

  // ── Helpers ────────────────────────────────────────────────────────────────
  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fmtEur(val) {
    if (val == null || val === 0 || val === '') return '--';
    return '\u20ac' + parseFloat(val).toFixed(2);
  }

  function condClass(c) {
    var map = { NM: 'cwcdm-cond-nm', LP: 'cwcdm-cond-lp', MP: 'cwcdm-cond-mp', HP: 'cwcdm-cond-hp' };
    return map[c] || '';
  }

  // ── Swipe-to-close op mobiel ───────────────────────────────────────────────
  var _touchStartY = 0;
  modal.addEventListener('touchstart', function (e) {
    _touchStartY = e.touches[0].clientY;
  }, { passive: true });
  modal.addEventListener('touchmove', function (e) {
    var dy = e.touches[0].clientY - _touchStartY;
    if (dy > 80 && modal.scrollTop === 0) close();
  }, { passive: true });

  // ── Sluiten via overlay klik ───────────────────────────────────────────────
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) close();
  });

  // ── Open ───────────────────────────────────────────────────────────────────
  function open(opts) {
    opts = opts || {};
    _card    = opts.card    || {};
    _mode    = opts.mode    || 'pricedex';
    _listId  = opts.listId  || null;
    _lists   = opts.lists   || [];
    _onSave  = opts.onSave  || null;
    _onClose = opts.onClose || null;
    _authFn  = opts.getAuth || null;
    _qty     = opts.qty     || 1;

    renderHeader();
    renderPrices();
    renderContext();

    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  // ── Sluiten ────────────────────────────────────────────────────────────────
  function close() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    _card = null;
    if (typeof _onClose === 'function') _onClose();
    _onClose = null;
    _onSave  = null;
  }

  // ── Header ────────────────────────────────────────────────────────────────
  function renderHeader() {
    var card = _card;
    var imgUrl = card.image_url || card.imageUrl || (card.images && (card.images.large || card.images.small)) || '';
    if (imgUrl) {
      imgWrap.innerHTML = '<img class="cwcdm-card-img" src="' + esc(imgUrl) + '" alt="' + esc(card.card_name || card.name || '') + '" loading="lazy">';
    } else {
      imgWrap.innerHTML = '<div class="cwcdm-card-img-placeholder">&#x1F0CF;</div>';
    }

    var cmUrl = card.cardmarket_url || (card.cardmarket_id ? 'https://www.cardmarket.com/en/Pokemon/Products/Singles?searchString=' + encodeURIComponent(card.card_name || card.name || '') : '');
    if (cmUrl) {
      cmLink.href = cmUrl;
      cmLink.style.display = '';
    } else {
      cmLink.style.display = 'none';
    }

    if (titleEl) titleEl.textContent = card.card_name || card.name || '';
    if (subEl) {
      var fr = (card.franchise || '').toUpperCase();
      var set = card.set_id || card.set || '';
      var num = card.card_number || card.number || '';
      subEl.textContent = [fr, set, num ? '#' + num : ''].filter(Boolean).join(' · ');
    }
  }

  // ── Prijzen (placeholder) ──────────────────────────────────────────────────
  function renderPrices() {
    var nm    = document.getElementById('cwcdm-price-nm');
    var trend = document.getElementById('cwcdm-price-trend');
    var avg   = document.getElementById('cwcdm-price-avg');
    // Probeer data uit card object te halen (Sprint 2 vult dit via live API)
    var card = _card;
    if (nm)    nm.textContent    = card.price_nm    ? fmtEur(card.price_nm)    : '--';
    if (trend) trend.textContent = card.price_trend ? fmtEur(card.price_trend) : '--';
    if (avg)   avg.textContent   = card.price_avg   ? fmtEur(card.price_avg)   : '--';
  }

  // ── Context blok ──────────────────────────────────────────────────────────
  function renderContext() {
    if (!contextEl) return;
    if (_mode === 'collection') {
      renderCollectionContext();
    } else {
      renderPricedexContext();
    }
  }

  // ── Collection mode ────────────────────────────────────────────────────────
  function renderCollectionContext() {
    var item = _card;
    _qty = item.qty || 1;
    var condition = item.condition || 'NM';
    var price = item.purchase_price != null ? parseFloat(item.purchase_price).toFixed(2) : '';
    var date = item.purchase_date ? String(item.purchase_date).split('T')[0] : '';

    var listsOpts = '';
    (_lists || []).forEach(function (l) {
      var sel = String(l.id) === String(_listId) ? ' selected' : '';
      listsOpts += '<option value="' + esc(l.id) + '"' + sel + '>' + esc(l.icon + ' ' + l.name) + '</option>';
    });

    contextEl.innerHTML =
      '<div class="cwcdm-row">' +
        '<span class="cwcdm-label">Aantal</span>' +
        '<div class="cwcdm-qty-wrap">' +
          '<button class="cwcdm-qty-btn" id="cwcdm-qty-minus" type="button" aria-label="Minder">&#8722;</button>' +
          '<span class="cwcdm-qty-val" id="cwcdm-qty-val">' + _qty + '</span>' +
          '<button class="cwcdm-qty-btn" id="cwcdm-qty-plus" type="button" aria-label="Meer">&#43;</button>' +
        '</div>' +
      '</div>' +
      '<div class="cwcdm-row">' +
        '<span class="cwcdm-label">Conditie</span>' +
        '<select class="cwcdm-field" id="cwcdm-cond-sel" style="max-width:200px">' +
          '<option value="NM"' + (condition === 'NM' ? ' selected' : '') + '>NM - Near Mint</option>' +
          '<option value="LP"' + (condition === 'LP' ? ' selected' : '') + '>LP - Lightly Played</option>' +
          '<option value="MP"' + (condition === 'MP' ? ' selected' : '') + '>MP - Moderately Played</option>' +
          '<option value="HP"' + (condition === 'HP' ? ' selected' : '') + '>HP - Heavily Played</option>' +
        '</select>' +
      '</div>' +
      '<div class="cwcdm-row">' +
        '<span class="cwcdm-label">Aankoopprijs</span>' +
        '<input type="number" class="cwcdm-field" id="cwcdm-price-input" placeholder="0.00" min="0" step="0.01" value="' + esc(price) + '" style="max-width:130px">' +
      '</div>' +
      '<div class="cwcdm-row">' +
        '<span class="cwcdm-label">Aankoopdatum</span>' +
        '<input type="date" class="cwcdm-field" id="cwcdm-date-input" value="' + esc(date) + '" style="max-width:170px">' +
      '</div>' +
      (_lists.length > 1 ?
        '<div class="cwcdm-row">' +
          '<span class="cwcdm-label">In lijst</span>' +
          '<select class="cwcdm-list-select" id="cwcdm-list-sel">' + listsOpts + '</select>' +
        '</div>' : '') +
      '<div class="cwcdm-actions">' +
        '<button class="cwcdm-btn cwcdm-btn--primary" id="cwcdm-save-btn" type="button">Opslaan</button>' +
        (_lists.length > 1 ?
          '<button class="cwcdm-btn cwcdm-btn--ghost" id="cwcdm-move-btn" type="button">Verplaats naar...</button>' +
          '<button class="cwcdm-btn cwcdm-btn--ghost" id="cwcdm-copy-btn" type="button">Kopieer naar...</button>'
          : '') +
        '<span class="cwcdm-btn-spacer"></span>' +
        '<button class="cwcdm-btn cwcdm-btn--danger" id="cwcdm-delete-btn" type="button">Verwijderen</button>' +
      '</div>';

    bindCollectionEvents();
  }

  function bindCollectionEvents() {
    var qtyVal   = document.getElementById('cwcdm-qty-val');
    var qtyMinus = document.getElementById('cwcdm-qty-minus');
    var qtyPlus  = document.getElementById('cwcdm-qty-plus');
    var saveBtn  = document.getElementById('cwcdm-save-btn');
    var delBtn   = document.getElementById('cwcdm-delete-btn');
    var moveBtn  = document.getElementById('cwcdm-move-btn');
    var copyBtn  = document.getElementById('cwcdm-copy-btn');

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        if (_qty > 1) { _qty--; if (qtyVal) qtyVal.textContent = _qty; }
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        _qty++;
        if (qtyVal) qtyVal.textContent = _qty;
      });
    }

    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var condSel    = document.getElementById('cwcdm-cond-sel');
        var priceInput = document.getElementById('cwcdm-price-input');
        var dateInput  = document.getElementById('cwcdm-date-input');
        var fields = {
          qty:            _qty,
          condition:      condSel   ? condSel.value   : 'NM',
          purchase_price: priceInput && priceInput.value ? parseFloat(priceInput.value) : null,
          purchase_date:  dateInput  && dateInput.value  ? dateInput.value : null
        };
        if (typeof _onSave === 'function') _onSave({ action: 'save', fields: fields });
        close();
      });
    }

    if (delBtn) {
      delBtn.addEventListener('click', function () {
        if (typeof _onSave === 'function') _onSave({ action: 'delete' });
        close();
      });
    }

    if (moveBtn) {
      moveBtn.addEventListener('click', function () {
        var listSel = document.getElementById('cwcdm-list-sel');
        var targetId = listSel ? parseInt(listSel.value, 10) : null;
        if (targetId && typeof _onSave === 'function') _onSave({ action: 'move', targetListId: targetId });
        close();
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var listSel = document.getElementById('cwcdm-list-sel');
        var targetId = listSel ? parseInt(listSel.value, 10) : null;
        if (targetId && typeof _onSave === 'function') _onSave({ action: 'copy', targetListId: targetId });
        close();
      });
    }
  }

  // ── PriceDex mode ──────────────────────────────────────────────────────────
  var CWCDM_EMOJI_OPTIONS = ['📦', '💰', '⭐', '🔥', '💎', '🎯', '🏆', '🛡️', '📈', '🎴', '🌟', '🃏'];
  var _newListSelectedEmoji = '📦';

  function buildListSelectOptions() {
    var opts = '';
    (_lists || []).forEach(function (l) {
      var count = l.item_count != null ? parseInt(l.item_count, 10) : 0;
      var label = esc((l.icon || '📦') + ' ' + l.name + ' (' + count + ' kaarten)');
      var sel = String(l.id) === String(_listId) ? ' selected' : '';
      opts += '<option value="' + esc(l.id) + '"' + sel + '>' + label + '</option>';
    });
    return opts;
  }

  function buildEmojiPicker() {
    var btns = '';
    CWCDM_EMOJI_OPTIONS.forEach(function (emoji) {
      var active = emoji === _newListSelectedEmoji ? ' cwcdm-emoji-btn--active' : '';
      btns += '<button type="button" class="cwcdm-emoji-btn' + active + '" data-emoji="' + esc(emoji) + '">' + emoji + '</button>';
    });
    return btns;
  }

  function renderPricedexContext() {
    _qty = 1;
    _newListSelectedEmoji = '📦';

    var loggedIn = !!(window.cwcrIsLoggedIn && window.cwcrCustomer);
    var hasLists = loggedIn && _lists.length > 0;

    var listBlock = '';
    if (hasLists) {
      listBlock =
        '<div class="cwcdm-row">' +
          '<span class="cwcdm-label">In lijst</span>' +
          '<select class="cwcdm-list-select" id="cwcdm-list-select">' + buildListSelectOptions() + '</select>' +
        '</div>' +
        '<div class="cwcdm-new-list-toggle-row">' +
          '<button type="button" class="cwcdm-new-list-toggle" id="cwcdm-new-list-toggle">+ Nieuwe lijst</button>' +
        '</div>' +
        '<div class="cwcdm-new-list-form" id="cwcdm-new-list-form">' +
          '<div class="cwcdm-new-list-emoji-row" id="cwcdm-new-list-emoji-row">' + buildEmojiPicker() + '</div>' +
          '<div class="cwcdm-new-list-input-row">' +
            '<input type="text" class="cwcdm-new-list-name cwcdm-field" id="cwcdm-new-list-name" placeholder="Naam van de lijst..." maxlength="60">' +
            '<button type="button" class="cwcdm-btn cwcdm-btn--primary cwcdm-new-list-confirm" id="cwcdm-new-list-confirm">Aanmaken</button>' +
          '</div>' +
          '<div class="cwcdm-new-list-error" id="cwcdm-new-list-error"></div>' +
        '</div>';
    }

    contextEl.innerHTML =
      listBlock +
      '<div class="cwcdm-row">' +
        '<span class="cwcdm-label">Aantal</span>' +
        '<div class="cwcdm-qty-wrap">' +
          '<button class="cwcdm-qty-btn" id="cwcdm-qty-minus" type="button" aria-label="Minder">&#8722;</button>' +
          '<span class="cwcdm-qty-val" id="cwcdm-qty-val">1</span>' +
          '<button class="cwcdm-qty-btn" id="cwcdm-qty-plus" type="button" aria-label="Meer">&#43;</button>' +
        '</div>' +
      '</div>' +
      '<div class="cwcdm-row">' +
        '<span class="cwcdm-label">Conditie</span>' +
        '<select class="cwcdm-field" id="cwcdm-cond-sel" style="max-width:200px">' +
          '<option value="NM">NM - Near Mint</option>' +
          '<option value="LP">LP - Lightly Played</option>' +
          '<option value="MP">MP - Moderately Played</option>' +
          '<option value="HP">HP - Heavily Played</option>' +
        '</select>' +
      '</div>' +
      '<div class="cwcdm-row">' +
        '<span class="cwcdm-label">Aankoopprijs</span>' +
        '<input type="number" class="cwcdm-field" id="cwcdm-price-input" placeholder="0.00" min="0" step="0.01" value="' + (_card && _card.price_nm ? parseFloat(_card.price_nm).toFixed(2) : '') + '" title="Standaard ingevuld met huidige NM marktprijs — pas aan indien nodig" style="max-width:130px">' +
      '</div>' +
      '<div class="cwcdm-actions">' +
        (loggedIn ?
          '<button class="cwcdm-btn cwcdm-btn--primary" id="cwcdm-add-btn" type="button">Toevoegen aan lijst</button>' :
          '<button class="cwcdm-btn cwcdm-btn--primary" id="cwcdm-login-btn" type="button">Inloggen om toe te voegen</button>') +
        '<button class="cwcdm-btn cwcdm-btn--ghost" id="cwcdm-cancel-btn" type="button">Annuleren</button>' +
      '</div>';

    bindPricedexEvents();
  }

  function bindPricedexEvents() {
    var qtyVal      = document.getElementById('cwcdm-qty-val');
    var qtyMinus    = document.getElementById('cwcdm-qty-minus');
    var qtyPlus     = document.getElementById('cwcdm-qty-plus');
    var addBtn      = document.getElementById('cwcdm-add-btn');
    var loginBtn    = document.getElementById('cwcdm-login-btn');
    var cancelBtn   = document.getElementById('cwcdm-cancel-btn');
    var listSelect  = document.getElementById('cwcdm-list-select');
    var toggleBtn   = document.getElementById('cwcdm-new-list-toggle');
    var newListForm = document.getElementById('cwcdm-new-list-form');
    var emojiRow    = document.getElementById('cwcdm-new-list-emoji-row');
    var nameInput   = document.getElementById('cwcdm-new-list-name');
    var confirmBtn  = document.getElementById('cwcdm-new-list-confirm');
    var errorEl     = document.getElementById('cwcdm-new-list-error');

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        if (_qty > 1) { _qty--; if (qtyVal) qtyVal.textContent = _qty; }
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        _qty++;
        if (qtyVal) qtyVal.textContent = _qty;
      });
    }

    // Lijst-select sync naar _listId
    if (listSelect) {
      _listId = parseInt(listSelect.value, 10) || _listId;
      listSelect.addEventListener('change', function () {
        _listId = parseInt(listSelect.value, 10);
      });
    }

    // Toggle nieuwe lijst form
    if (toggleBtn && newListForm) {
      toggleBtn.addEventListener('click', function () {
        var open = newListForm.classList.toggle('cwcdm-new-list-form--open');
        toggleBtn.textContent = open ? '- Annuleren' : '+ Nieuwe lijst';
        if (!open && errorEl) errorEl.textContent = '';
      });
    }

    // Emoji picker
    if (emojiRow) {
      emojiRow.addEventListener('click', function (e) {
        var btn = e.target.closest('.cwcdm-emoji-btn');
        if (!btn) return;
        _newListSelectedEmoji = btn.getAttribute('data-emoji') || '📦';
        emojiRow.querySelectorAll('.cwcdm-emoji-btn').forEach(function (b) {
          b.classList.toggle('cwcdm-emoji-btn--active', b === btn);
        });
      });
    }

    // Nieuwe lijst aanmaken
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var name = nameInput ? nameInput.value.trim() : '';
        if (!name) {
          if (errorEl) errorEl.textContent = 'Geef je lijst een naam.';
          if (nameInput) nameInput.focus();
          return;
        }
        if (errorEl) errorEl.textContent = '';

        // Auth ophalen via _authFn of via globals
        var auth = null;
        if (typeof _authFn === 'function') {
          auth = _authFn();
        } else if (window.cwcrCustomer && window.cwcrHmacToken) {
          auth = { cid: String(window.cwcrCustomer.id), email: window.cwcrCustomer.email, token: window.cwcrHmacToken };
        }
        if (!auth || !auth.cid || !auth.email) {
          if (errorEl) errorEl.textContent = 'Sessie verlopen, herlaad de pagina.';
          return;
        }

        var apiBase = (typeof cwcrApiUrl !== 'undefined' && cwcrApiUrl) ? cwcrApiUrl.replace(/\/$/, '') : '';
        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Aanmaken...';

        fetch(apiBase + '/api/cw/collection/lists', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cid: auth.cid, email: auth.email, token: auth.token, name: name, icon: _newListSelectedEmoji, color: '#7B5EA7' })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            confirmBtn.disabled = false;
            confirmBtn.textContent = 'Aanmaken';
            if (data && data.list) {
              var newList = data.list;
              _lists.push(newList);
              _listId = newList.id;
              // Voeg optie toe aan select en selecteer hem
              if (listSelect) {
                var count = newList.item_count != null ? parseInt(newList.item_count, 10) : 0;
                var opt = document.createElement('option');
                opt.value = newList.id;
                opt.textContent = (newList.icon || '📦') + ' ' + newList.name + ' (' + count + ' kaarten)';
                opt.selected = true;
                listSelect.appendChild(opt);
              }
              // Sluit form
              if (newListForm) newListForm.classList.remove('cwcdm-new-list-form--open');
              if (toggleBtn) toggleBtn.textContent = '+ Nieuwe lijst';
              if (nameInput) nameInput.value = '';
            } else {
              if (errorEl) errorEl.textContent = (data && data.error) || 'Kon lijst niet aanmaken.';
            }
          })
          .catch(function () {
            confirmBtn.disabled = false;
            confirmBtn.textContent = 'Aanmaken';
            if (errorEl) errorEl.textContent = 'Netwerkfout, probeer opnieuw.';
          });
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', close);
    }

    if (loginBtn) {
      loginBtn.addEventListener('click', function () {
        window.location.href = '/account/login?return_to=' + encodeURIComponent(window.location.pathname);
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var condSel    = document.getElementById('cwcdm-cond-sel');
        var priceInput = document.getElementById('cwcdm-price-input');
        // Sync _listId vanuit select voor het geval de user hem recent wijzigde
        if (listSelect) _listId = parseInt(listSelect.value, 10) || _listId;
        var fields = {
          qty:            _qty,
          condition:      condSel   ? condSel.value   : 'NM',
          purchase_price: priceInput && priceInput.value ? parseFloat(priceInput.value) : null,
          list_id:        _listId
        };
        if (typeof _onSave === 'function') {
          addBtn.disabled = true;
          addBtn.textContent = 'Toevoegen...';
          _onSave({ action: 'add', fields: fields, done: function () {
            addBtn.disabled = false;
            addBtn.textContent = 'Toevoegen aan lijst';
          }});
        }
      });
    }
  }

  // ── Public API ────────────────────────────────────────────────────────────
  window.CWCardDetail = {
    open:  open,
    close: close
  };

})();
